<template>
  <section class="pageHero" :class="colorScheme" v-if="page">
    <div class="container">
      <div class="img" :style="{ backgroundImage: `url(${ featuredImage })` }" v-if="page.image"></div>
      <div class="hero-content">
        <h2 v-html="page.hero.title"></h2>
        <div v-html="page.hero.lead"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'hero',
  props: ['page', 'colorScheme'],
  computed: {
    featuredImage () {
      let vm = this
      if (vm.page && vm.page.image) {
        let image = vm.page.image.large
        if (process.env.NODE_ENV === 'development') {
          image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
        }
        return image
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Hero.vue?d50c60b0